export default {
  errorMessage: {
    startAtUtc: 'Čas začiatku nemôže byť neskorší ako čas ukončenia.',
    endAtUtc: 'Čas ukončenia nemôže byť skorší ako čas začiatku',
  },
};
